import { render, staticRenderFns } from "./VerificationSection.vue?vue&type=template&id=1120f7c6&scoped=true"
import script from "./VerificationSection.vue?vue&type=script&lang=js"
export * from "./VerificationSection.vue?vue&type=script&lang=js"
import style0 from "./VerificationSection.vue?vue&type=style&index=0&id=1120f7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1120f7c6",
  null
  
)

export default component.exports